import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Process from "@/pages/home/components/Process";
import Categories from "@/pages/home/components/Categories";
import SubmitForm from "@/pages/home/components/SubmitForm";
import Cases from "@/pages/home/components/Cases";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { faqs } from "@/mocks/home";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

export default function Home() {
  useScrollReveal();

  return (
    <div className="w-full bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Process />
        <Categories />
        <SubmitForm />
        <Cases />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}